import React from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from '../../components/Navbar';
import Footer from '../../components/Footer';
import { ArrowLeft } from 'lucide-react';

const Datenschutz = ({ user, onLogout }) => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar user={user} onLogout={onLogout} />
      
      <div className="pt-24 pb-12 px-4">
        <div className="max-w-4xl mx-auto">
          <button
            onClick={() => navigate(-1)}
            className="flex items-center gap-2 text-gray-600 hover:text-[#2B2142] mb-6"
          >
            <ArrowLeft className="w-5 h-5" />
            Zurück
          </button>

          <div className="bg-white rounded-3xl shadow-lg p-4 sm:p-6 md:p-12">
            <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-8 break-words">Datenschutzerklärung</h1>

            <div className="space-y-8 text-gray-700 leading-relaxed break-words">
              <section>
                <h2 className="text-xl sm:text-2xl font-semibold text-gray-900 mb-4">1. Allgemeine Hinweise</h2>
                <p>Der Schutz deiner persönlichen Daten ist uns wichtig. In dieser Datenschutzerklärung informieren wir dich darüber, welche personenbezogenen Daten wir im Rahmen der Nutzung von EventConnect – Hayri Tugkan Diyaroglu verarbeiten, zu welchem Zweck und wie wir damit umgehen.</p>
                <p className="mt-4">Wenn du Kontakt mit uns aufnimmst (z. B. per E-Mail an <a href="mailto:kontakt@evconn.de" className="text-[#2B2142] hover:underline">kontakt@evconn.de</a>), werden die von dir gemachten Angaben zur Bearbeitung der Anfrage verwendet.</p>
              </section>

              <section>
                <h2 className="text-xl sm:text-2xl font-semibold text-gray-900 mb-4">2. Verantwortlicher</h2>
                <p>Verantwortlicher im Sinne der Datenschutzgesetze, insbesondere der DSGVO, ist:</p>
                <div className="mt-4 p-4 bg-gray-100 rounded-lg">
                  <p><strong>EventConnect – Hayri Tugkan Diyaroglu</strong></p>
                  <p>Hauptstätter Straße 112</p>
                  <p>70178 Stuttgart</p>
                  <p>Deutschland</p>
                  <p className="mt-2">E-Mail: <a href="mailto:kontakt@evconn.de" className="text-[#2B2142] hover:underline">kontakt@evconn.de</a></p>
                </div>
              </section>

              <section>
                <h2 className="text-xl sm:text-2xl font-semibold text-gray-900 mb-4">3. Erhobene Daten</h2>
                <p className="mb-4">Wir erheben folgende Kategorien personenbezogener Daten:</p>
                <ul className="list-disc list-inside space-y-2 ml-2 sm:ml-4">
                  <li><strong>Accountdaten:</strong> E-Mail-Adresse, Passwort (verschlüsselt), gewählte Rolle (Kunde/Dienstleister)</li>
                  <li><strong>Profildaten:</strong> Firmenname, Kontaktdaten, Standort, Kategorien, Beschreibungen, hochgeladene Bilder</li>
                  <li><strong>Nutzungsdaten:</strong> IP-Adresse, Browser-Typ, Betriebssystem, Zeitstempel von Seitenaufrufen</li>
                  <li><strong>Kommunikationsdaten:</strong> Anfragen, Nachrichten zwischen Nutzern und Dienstleistern</li>
                  <li><strong>Zahlungsdaten:</strong> Abrechnungsinformationen für Dienstleister-Abonnements</li>
                </ul>
              </section>

              <section>
                <h2 className="text-xl sm:text-2xl font-semibold text-gray-900 mb-4">4. Zweck der Datenverarbeitung</h2>
                <p className="mb-4">Wir verarbeiten deine Daten zu folgenden Zwecken:</p>
                <ul className="list-disc list-inside space-y-2 ml-2 sm:ml-4">
                  <li>Bereitstellung und Betrieb der EventConnect-Plattform</li>
                  <li>Ermöglichung der Kommunikation zwischen Kunden und Dienstleistern</li>
                  <li>Abrechnung von Dienstleister-Abonnements</li>
                  <li>Verbesserung unserer Services und Nutzererfahrung</li>
                  <li>Schutz vor Missbrauch und Spam</li>
                </ul>
              </section>

              <section>
                <h2 className="text-xl sm:text-2xl font-semibold text-gray-900 mb-4">5. Rechtsgrundlagen</h2>
                <p className="mb-4">Die Verarbeitung personenbezogener Daten erfolgt auf Grundlage folgender Rechtsgrundlagen gemäß DSGVO:</p>
                <ul className="list-disc list-inside space-y-2 ml-2 sm:ml-4">
                  <li>Art. 6 Abs. 1 lit. b DSGVO (Vertragserfüllung)</li>
                  <li>Art. 6 Abs. 1 lit. a DSGVO (Einwilligung)</li>
                  <li>Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse)</li>
                </ul>
              </section>

              <section>
                <h2 className="text-xl sm:text-2xl font-semibold text-gray-900 mb-4">6. Speicherdauer</h2>
                <p>Deine personenbezogenen Daten werden gespeichert, solange dies für die Bereitstellung unserer Dienste erforderlich ist oder gesetzliche Aufbewahrungspflichten bestehen. Nach Beendigung deines Accounts werden deine Daten gelöscht oder anonymisiert.</p>
              </section>

              <section>
                <h2 className="text-xl sm:text-2xl font-semibold text-gray-900 mb-4">7. Weitergabe an Dritte</h2>
                <p className="mb-4">Wir geben deine Daten nur in folgenden Fällen an Dritte weiter:</p>
                <ul className="list-disc list-inside space-y-2 ml-2 sm:ml-4">
                  <li><strong>Hosting-Provider:</strong> Zur Bereitstellung der technischen Infrastruktur</li>
                  <li><strong>Zahlungsdienstleister (Stripe):</strong> Zur Abwicklung von Abo-Zahlungen für Dienstleister. Stripe verarbeitet Zahlungsinformationen gemäß eigener Datenschutzrichtlinien (<a href="https://stripe.com/de/privacy" target="_blank" rel="noopener noreferrer" className="text-[#2B2142] hover:underline break-all">https://stripe.com/de/privacy</a>)</li>
                  <li><strong>E-Mail-Dienst (SendGrid):</strong> Zum Versand von Benachrichtigungen, Passwort-Resets und Rechnungen</li>
                  <li><strong>Rechtliche Verpflichtungen:</strong> Wenn wir gesetzlich dazu verpflichtet sind</li>
                </ul>
                <p className="mt-4">Alle externen Dienstleister sind vertraglich zur Einhaltung des Datenschutzes verpflichtet und verarbeiten Daten nur im Rahmen unserer Weisungen.</p>
              </section>

              <section>
                <h2 className="text-xl sm:text-2xl font-semibold text-gray-900 mb-4">8. Deine Rechte</h2>
                <p className="mb-4">Du hast folgende Rechte bezüglich deiner personenbezogenen Daten:</p>
                <ul className="list-disc list-inside space-y-2 ml-2 sm:ml-4">
                  <li><strong>Auskunft:</strong> Du kannst Auskunft über die von uns verarbeiteten Daten verlangen</li>
                  <li><strong>Berichtigung:</strong> Du kannst die Korrektur unrichtiger Daten verlangen</li>
                  <li><strong>Löschung:</strong> Du kannst die Löschung deiner Daten verlangen</li>
                  <li><strong>Einschränkung:</strong> Du kannst die Einschränkung der Verarbeitung verlangen</li>
                  <li><strong>Datenübertragbarkeit:</strong> Du kannst deine Daten in einem strukturierten Format erhalten</li>
                  <li><strong>Widerspruch:</strong> Du kannst der Verarbeitung deiner Daten widersprechen</li>
                </ul>
              </section>

              <section>
                <h2 className="text-xl sm:text-2xl font-semibold text-gray-900 mb-4">9. Cookies</h2>
                <p>EventConnect verwendet Cookies, um die Nutzung der Website zu verbessern. Cookies sind kleine Textdateien, die auf deinem Gerät gespeichert werden. Du kannst deine Cookie-Einstellungen jederzeit in deinem Browser anpassen.</p>
              </section>

              <section>
                <h2 className="text-xl sm:text-2xl font-semibold text-gray-900 mb-4">10. Kontakt für Datenschutzanfragen</h2>
                <p>Bei Fragen zum Datenschutz oder zur Ausübung deiner Rechte wende dich bitte an:</p>
                <p className="mt-2">E-Mail: <a href="mailto:kontakt@evconn.de" className="text-[#2B2142] hover:underline">kontakt@evconn.de</a></p>
              </section>

              <section>
                <h2 className="text-xl sm:text-2xl font-semibold text-gray-900 mb-4">11. Änderungen dieser Datenschutzerklärung</h2>
                <p>Wir behalten uns vor, diese Datenschutzerklärung bei Bedarf anzupassen, um sie an geänderte Rechtslage oder Änderungen unserer Dienste anzupassen.</p>
                <p className="mt-2">Stand: Januar 2025</p>
              </section>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Datenschutz;
